import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-breadcrumb",
  "aria-label": "Fil d'Ariane"
}
const _hoisted_2 = { class: "breadcrumb mb-3" }
const _hoisted_3 = ["aria-current"]
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.items.length > 1)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("ol", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `${item.label}-${index}`,
              class: _normalizeClass(["breadcrumb-item", { active: index === _ctx.items.length - 1 }]),
              "aria-current": index === _ctx.items.length - 1 ? 'page' : undefined
            }, [
              (index < _ctx.items.length - 1 && item.to)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: item.to
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.label), 1))
            ], 10, _hoisted_3))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}